import {
  DOWNLOAD_BAZAAR_INTEREST_LIST_FAILURE,
  DOWNLOAD_BAZAAR_INTEREST_LIST_REQUEST,
  DOWNLOAD_BAZAAR_INTEREST_LIST_RESET,
  DOWNLOAD_BAZAAR_INTEREST_LIST_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const downloadBazaarInterestListReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_BAZAAR_INTEREST_LIST_REQUEST:
      return { ...state, loading: true, error: false, success: false, message: "" }
    case DOWNLOAD_BAZAAR_INTEREST_LIST_SUCCESS:
      return { ...state, loading: false, success: true, error: false, message: action.payload.message || "" }
    case DOWNLOAD_BAZAAR_INTEREST_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload.error || "Something went wrong", success: false, message: "" }
    case DOWNLOAD_BAZAAR_INTEREST_LIST_RESET:
      return { ...initialState }
    default:
      return state
  }
}

export default downloadBazaarInterestListReducer
